<script>
    export default {
        props: [
            'stat', 'getRoute',
            'initMaxRangeMonths', 'initMainYearStart', 'initMainMonthStart', 'initMainYearEnd' , 'initMainMonthEnd',
            'initMainState', 'initMainType', 'initConsultantLevel'
        ],
        data() {
            return {
                maxRangeMonths: this.initMaxRangeMonths,
                mainYearStart: this.initMainYearStart,
                mainMonthStart: this.initMainMonthStart,
                mainYearEnd: this.initMainYearEnd,
                mainMonthEnd: this.initMainMonthEnd,
                mainState: this.initMainState,
                mainNumMonths: 0,
                mainType: this.initMainType,
                consultantId: this.consultantId,
                consultantLevel: this.initConsultantLevel,
                table: false,
            }
        },
        mounted: function(){
            let statisticFilter = this;

            statisticFilter.initListeners();

            statisticFilter.applyFilter();

            Event.$on('consultantLevelChanged', function (consultantLevel) {
                statisticFilter.consultantLevel = consultantLevel;
                statisticFilter.applyFilter();
            });

            Event.$on('tableDataFetch', function (statisticChart, event) {
                if(statisticFilter.stat == statisticChart.stat){
                    statisticFilter.tableFetch(event.target);
                }
            });

        },
        methods: {
            initListeners: function () {
                let statisticFilter = this;

                $(document).ready(function(){
                    //main
                    $(statisticFilter.$el).on("change", "[name='main_year_start']", function(){
                        statisticFilter.mainYearStart = Number($(this).val());
                        statisticFilter.calcNumMonths();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_month_start']", function(){
                        statisticFilter.mainMonthStart = Number($(this).val());
                        statisticFilter.calcNumMonths();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_year_end']", function(){
                        statisticFilter.mainYearEnd = Number($(this).val());
                        statisticFilter.calcNumMonths();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_month_end']", function(){
                        statisticFilter.mainMonthEnd = Number($(this).val());
                        statisticFilter.calcNumMonths();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_type']", function(){
                        statisticFilter.mainType = $(this).val();
                    });

                    $(statisticFilter.$el).on("change", "[name='main_state']", function(){
                        statisticFilter.mainState = $(this).val();
                    });
                });

            },
            tableFetch: function(element){
                let statisticFilter = this;

                if($(element).attr("aria-expanded") == undefined || $(element).attr("aria-expanded") == "false"){
                    statisticFilter.table = true;
                    statisticFilter.applyFilter();
                }else{
                    statisticFilter.table = false;
                }
            },
            applyFilter: function () {
                let statisticFilter = this;

                statisticFilter.calcNumMonths();
                
                statisticFilter.$parent.loading = true;

                //TODO AJAX CALL AND EMIT EVENT ON RESPONSE WITH NEW DATA
                axios.get(this.getRoute, {
                        params: {
                            statistic: statisticFilter.stat,
                            mainType: statisticFilter.mainType,
                            mainYearStart: statisticFilter.mainYearStart,
                            mainMonthStart: statisticFilter.mainMonthStart,
                            mainYearEnd: statisticFilter.mainYearEnd,
                            mainMonthEnd: statisticFilter.mainMonthEnd,
                            mainState: statisticFilter.mainState,
                            consultantLevel: statisticFilter.consultantLevel,
                            table: statisticFilter.table,
                        }
                    })
                    .then((res) => {
                        let data = res.data.data;
                        Event.$emit('filterApplied', statisticFilter, data);
                    })
                    .catch((err) => {
                        console.log(err);
                    });

            },
            calcNumMonths: function () {
                let statisticFilter = this;

                statisticFilter.mainNumMonths = 0;
                for(let year = statisticFilter.mainYearStart; year <= statisticFilter.mainYearEnd; year++){
                    let month_start = 1;
                    let month_end = 12;
                    if(year == statisticFilter.mainYearStart){
                        month_start = statisticFilter.mainMonthStart;
                    }
                    if(year == statisticFilter.mainYearEnd){
                        month_end = statisticFilter.mainMonthEnd;
                    }
                    for(let month = month_start; month <= month_end; month++){
                        statisticFilter.mainNumMonths++;
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/widgets/statistics-super-commissions/statisticFilter.vue